import styled from 'styled-components';

export const StyledPhoneSelect = styled.select`
  font-size: 14px;
  height: 100%;
  border: none;
`;
